<template>
  <div class="ReceiveHonor">
    <div class="cont">
      <ComTitlte titleEn=" HONOUR" titleZh="获得荣誉"></ComTitlte>
      <div class="main">
        <p>
          2005年，获得国家统计局颁发的“全国统计系统社情民意调查工作先进单位”称号；
          2012年，获得市委市政府颁发的“广州市创建全国文明城市积极贡献单位”称号；
          2022年1月获得广东省统计局颁发的“广东省第七次全国人口普查先进集体”称号，同时在项目质量、服务等方面得到广州市委、市政府、市人大、市政协、省统计局、市统计局、市规划和自然资源局、市人力资源和社会保障局、市商务局、市环保局、市交通运输局等近100个客户的好评。
        </p>
        <div class="imgList">
          <div class="swiper-container swiper_ReceiveHonor">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in imgList"
                :key="index"
              >
                <div class="bannerImg">
                  <img class="banner_bg" :src="item" alt="banner" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
import Swiper from "swiper";
export default {
  name: "ReceiveHonor",
  data() {
    return {
      imgList: [
        require("../../assets/img/company/d_img1.jpg"),
        require("../../assets/img/company/d_img2.jpg"),
        require("../../assets/img/company/d_img3.jpg"),
        require("../../assets/img/company/d_img4.jpg"),
      ],
    };
  },
  mounted() {
    new Swiper(".swiper_ReceiveHonor", {
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      autoResize: true,
      watchActiveIndex: true,
      lazyLoading: true, // 图片懒加载
      lazyLoadingInPrevNext: true,
      preventLinksPropagation: false,
      preventClicks: false,
      visibilityFullFit: true,
      updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
      calculateHeight: true, // 当值为true时，
      slidesPerView: 4,
    });
  },
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.ReceiveHonor {
  background: url("../../assets/img/index/cont_Company.png") no-repeat;
  background-size: cover;
  position: relative;
  &::after {
    display: block;
    content: "";
    width: 100%;
    height: 114px;
    background-color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
.cont {
  width: $themeMinWidth;
  margin: 0 auto;
  position: relative;
  z-index: 6;
  .main {
    padding: 50px 0 0 0;
    p {
      font-size: 16px;
      line-height: 30px;
      color: #666666;
      text-align: justify;
      text-indent: 32px;
    }
    .imgList {
      display: flex;
      width: $themeMinWidth;
      justify-content: space-between;
      padding: 20px 0 30px 0;
      /deep/ .bannerImg {
        margin: 0 6px;
        width: 284px;
        height: 198px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
